import React, { useEffect, useRef, useState } from "react";
import { SearchMapContainer } from "../../styled/shop";
import { Container as MapDiv, NaverMap, Marker } from "react-naver-maps";

const ShopSearchMap = ({ store, findStore, mapRef, center, setCenter, userLocation, isSearch }) => {
  const navermaps = typeof window !== "undefined" && window.naver && window.naver.maps;
  if (!navermaps) return null;

  return (
    <SearchMapContainer className={isSearch ? "searched" : ""}>
      <div className="mapField">
        <MapDiv
          style={{
            width: "100%",
            height: "100%",
          }}>
          <NaverMap
            ref={mapRef}
            center={new navermaps.LatLng(center.lat, center.lng)}
            defaultZoom={13}>
            {userLocation && (
              <Marker
                position={new navermaps.LatLng(userLocation.lat, userLocation.lng)}
                title="현재 위치"
                icon={{
                  content:
                    '<img src="/img/newMan.png" style="width: 30px; height: 30px; object-fit: contain;" />',
                }}
              />
            )}
            {findStore.map((item) => (
              <Marker
                key={item.cmpnyNo}
                position={new navermaps.LatLng(Number(item.latitude), Number(item.longitude))}
                title={item.cmpnyNm}
                icon={{
                  content:
                    '<img src="/img/marker.png" style="width: 30px; height: 30px; object-fit: contain;" />',
                }}
              />
            ))}
          </NaverMap>
        </MapDiv>
      </div>
    </SearchMapContainer>
  );
};

export default ShopSearchMap;
